export default __webpack_public_path__ + "static/media/rightCardBoard.987b0143.jpg";